import { render, staticRenderFns } from "./JudicialInfo.vue?vue&type=template&id=5662ec70"
import script from "./JudicialInfo.vue?vue&type=script&lang=js"
export * from "./JudicialInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports